import React, { Component } from 'react';
import FETCH from '../Fetch';
import { history } from '../App';

const { Provider, Consumer } = React.createContext();

class AuthContext extends Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: false,
      loading: false,
      user: null,
      login: this.login,
      logout: this.logout,
      passwordResetRedirect: false,
      resetPassword: this.resetPassword,
      updateData: this.updateData
    };

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  componentWillMount() {
    const token = localStorage.getItem('uniabuja-login-token') || null;
    const user =
      JSON.parse(localStorage.getItem('uniabuja-login-data')) || null;

    if (token && user) {
      this.setState({ isLoggedIn: true, user: user });
    }
  }

  logout = () => {
    localStorage.removeItem('uniabuja-login-token');
    localStorage.removeItem('uniabuja-login-data');
    this.setState({ isLoggedIn: false, user: null });
  };

  resetPassword = data => {
    return FETCH.resetPassword(data).then(response => {
      if (response.status && response.status === 'success') {
        history.push('/password_sent');
        return;
      }
      return response;
    });
  };

  login = loginData => {
    let self = this;
    return FETCH.login(loginData).then(response => {
      if (response.status === 'success') {
        // store static user data in localstorage
        localStorage.setItem(
          'uniabuja-login-data',
          JSON.stringify(response.data)
        );
        localStorage.setItem(
          'uniabuja-login-token',
          JSON.stringify(response.Authorization)
        );
        return self.setState({
          loading: false,
          isLoggedIn: true,
          user: response.data,
          token: response.Authorization
        });
      } else if (response.status === 'error') {
        return response;
      }
    });
  };

  updateData = data => {
    const userData = JSON.parse(localStorage.getItem('uniabuja-login-data'));
    console.log(userData);
    const updatedData = { ...userData, ...data };
    console.log(updatedData);
    localStorage.setItem('uniabuja-login-data', JSON.stringify(updatedData));
    this.setState({ user: updatedData });
  };

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}

export { AuthContext, Consumer as AuthConsumer };
